'use client';

import { c as _c } from "react/compiler-runtime";
import { useAuth } from '@clerk/nextjs';
import Link from 'next/link';
import { useEffect, useState } from 'react';
import { Icon } from '@/components/icon';
import { Button } from '@/components/ui/button';
import { SignUpModal } from '@/features/auth';
import { getContentAccessLevel } from '@/features/billing';
import { capture } from '@/features/tracking';
import { getWatchPathSegment } from '@/features/video';
type ExtendedInterviewsButtonProps = {
  levelOfAccess: 'public' | 'standard' | 'premium' | 'elite';
  videoId: string;
  videoTitle: string;
  userPrivileges: number;
};
export function ExtendedInterviewsButton(t0) {
  const $ = _c(24);
  const {
    levelOfAccess,
    videoId,
    videoTitle,
    userPrivileges
  } = t0;
  const {
    isSignedIn
  } = useAuth();
  const [mounted, setMounted] = useState(false);
  const [showSignUp, setShowSignUp] = useState(false);
  const hasAccess = getContentAccessLevel(userPrivileges, levelOfAccess);
  let t1;
  if ($[0] !== videoId) {
    t1 = getWatchPathSegment(videoId);
    $[0] = videoId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const watchSlug = t1;
  const watchUrl = `/watch/${watchSlug}`;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setMounted(true);
    };
    t3 = [];
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== isSignedIn) {
    t4 = e => {
      if (!isSignedIn) {
        e.preventDefault();
        setShowSignUp(true);
      }
    };
    $[4] = isSignedIn;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const handlePlayClick = t4;
  if (!mounted) {
    let t5;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <button type="button" className="z-3 flex h-full w-full items-center justify-center transition-opacity hover:opacity-90"><Icon name="play" className="size-10 max-w-10 max-[800px]:size-20 max-[800px]:max-w-20" /></button>;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    return t5;
  }
  if (isSignedIn && hasAccess) {
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <Icon name="play" className="size-10 max-w-10 max-[800px]:size-20 max-[800px]:max-w-20" />;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    let t6;
    if ($[8] !== watchUrl) {
      t6 = <Link href={watchUrl} className="z-3 flex h-full w-full items-center justify-center transition-opacity hover:opacity-90">{t5}</Link>;
      $[8] = watchUrl;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    return t6;
  }
  if (isSignedIn && !hasAccess) {
    let t5;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <Icon name="lock" className="size-2.5 max-[640px]:size-4" />;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    let t6;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <p className="text-sm tracking-[0.04rem] max-[640px]:text-[0.9rem]">Please <span className="font-bold italic">Pay It Forward</span> to view this interview</p>;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    let t7;
    if ($[12] !== levelOfAccess || $[13] !== videoTitle) {
      t7 = <div className="z-3 flex h-full w-full items-center justify-center text-center"><div className="flex flex-col items-center justify-center gap-1 max-[640px]:gap-2">{t5}{t6}<Button asChild={true} className="ease bg-christ-white-700 px-5 py-3 pb-2 font-bold text-base text-christ-black-900 uppercase leading-none tracking-[0.06rem] transition-all duration-300 hover:bg-christ-white-700 hover:opacity-90 max-[640px]:px-5 max-[640px]:py-3 max-[640px]:pb-2 max-[640px]:text-lg max-[800px]:text-2xl"><Link href="/pay-it-forward" onClick={() => {
              capture("viewing:locked_content_view", {
                content_type: videoTitle,
                required_tier: levelOfAccess === "standard" ? "standard" : levelOfAccess === "premium" ? "premium" : "elite"
              });
              capture("donation:pay_it_forward_modal_view", {
                trigger_point: "locked_content"
              });
            }}>Pay It Forward</Link></Button></div></div>;
      $[12] = levelOfAccess;
      $[13] = videoTitle;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    return t7;
  }
  let t5;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Icon name="play" className="size-10 max-w-10 max-[800px]:size-20 max-[800px]:max-w-20" />;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== handlePlayClick) {
    t6 = <button type="button" onClick={handlePlayClick} className="z-3 flex h-full w-full items-center justify-center transition-opacity hover:opacity-90">{t5}</button>;
    $[16] = handlePlayClick;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setShowSignUp(false);
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== showSignUp) {
    t8 = <SignUpModal isOpen={showSignUp} onClose={t7} />;
    $[19] = showSignUp;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t6 || $[22] !== t8) {
    t9 = <>{t6}{t8}</>;
    $[21] = t6;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
}